import React from "react";
import { NavLink } from "react-router-dom";
import { HouseDoor, Receipt, Person, Image, CalendarCheck, Grid} from "react-bootstrap-icons";
import logo from "../assets/image/Restaurant Icon.png";

const Sidebar = () => {
  return (
    <aside className="sidebar">
      <img src={logo} alt="Logo" className="sidebar-logo" />
      <ul>
      <li>
          <NavLink to="/dashboard" className="sidebar-link">
            <Grid size={20} className="sidebar-icon" /> Dashboard
          </NavLink>
        </li>
        <li>
          <NavLink to="/restaurant-tracker" className="sidebar-link">
            <HouseDoor size={20} className="sidebar-icon" /> Restaurant
          </NavLink>
        </li>
        <li>
          <NavLink to="/users" className="sidebar-link">
            <Person size={20} className="sidebar-icon" /> User
          </NavLink>
        </li>
        <li>
          <NavLink to="/bookings" className="sidebar-link">
            <CalendarCheck  size={20} className="sidebar-icon" /> Booking
          </NavLink>
        </li>
        <li>
          <NavLink to="/payments" className="sidebar-link">
            <Receipt size={20} className="sidebar-icon" /> Payment
          </NavLink>
        </li>
        <li>
          <NavLink to="/banners" className="sidebar-link">
            <Image size={20} className="sidebar-icon" /> Ad Image
          </NavLink>
        </li>
      </ul>
    </aside>
  );
};

export default Sidebar;
